import { Input } from 'components'
import { calculateDuration } from 'utils'

import './styles.scss'

interface Props {
  isValid: boolean
  startTime: string
  endTime: string
}

const extraCharsAmount = 3 // Кол-во символов для "запаса" по отступам

export const Duration = (props: Props) => {
  const { startTime, endTime, isValid } = props

  const duration = calculateDuration(startTime, endTime)
  const width = isValid && duration.length ? duration.length + extraCharsAmount : 0

  return (
    <div>
      <div className="time-inputs">
        <div className="input-label">Длительность</div>
        <Input
          style={{ width: width > 10 ? width + 'ch' : undefined }}
          className="form-input duration-input"
          value={isValid ? duration : ''}
          disabled
        />
      </div>
      {!isValid && <div className="error">Некорректная длительность</div>}
    </div>
  )
}
